// Crustdata v1 ``current_employers.seniority_level`` enum.
//
// Single source of truth, imported by BOTH:
//   - the People filter sidebar's seniority picker
//     (people-search-filters.component.tsx), and
//   - the agent-filter mapper (agent-filters-to-search-filters.ts),
//     so the Copilot's interpreted seniority validates against the exact
//     labels the page uses ("Vice President", not "vp").
//
// A vocab-sync test asserts the backend people_search tool's documented
// seniority enum stays a subset of these. Don't reorder or rename a value
// without updating the backend docstring in lockstep.
export const SENIORITY_LEVELS = [
  'Owner / Partner',
  'CXO',
  'Vice President',
  'Director',
  'Manager',
  'Senior',
  'Entry',
  'Training',
] as const;
